import React from 'react'
import context from '@/context'
import { DropDownList } from '@/components/dropDownList'

export default (props) => {
  return (
    <DropDownList
      className='AssigneeSelector'
      dataSource={context.api.userService.getLookupInternal}
      textField='name'
      onChange={({ item }) => props.onChange(item)}
      value={props.value}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/AssigneeSelector/AssigneeSelector.js